<template>
    <v-footer class="footer" style="padding-top: 200px">
        <v-row>
            <v-col>
                <p>
                    <strong>
                        Qwips Service Solutions AS<br>
                    </strong>
                    Drammensveien 167,<br>
                    N-0277 Oslo, Norway<br>
                    Ph. +47 22 22 44 00<br>
                    www.qwips.no<br>
                    Company ID NO997913434MVA<br>
                    Admin: erik@qwips.net<br>
                </p>
            </v-col>
            <v-col class="d-flex flex-column align-center justify-center">
                <v-spacer />
                <a href="https://www.facebook.com/QwipsService/" target="_blank">
                    <v-img class="ma-auto"
                        width="130"
                        :src="loadImage('images/FindUs-FB-RGB-BRC-Site-500.png')"
                        href="https://www.facebook.com/QwipsService/"></v-img>
                </a>
                <v-spacer />
                <a href="https://www.linkedin.com/company/31423924/" target="_blank">
                    <v-img class="ma-auto"
                        width="130"
                        :src="loadImage('logos/LI-Logo.png')"
                        href="https://www.facebook.com/QwipsService/"></v-img>
                </a>
                <v-spacer />
            </v-col>
            <v-col>
                <strong>
                    BUSINESS HOURS<br>
                </strong>
                Our support Hotline is available During opening hours CET.<br>
                Call us at (+47) 22 22 44 00, or email us at
                <strong>
                    support@qwips.no<br>
                </strong>
                Monday-Friday: 8am to 5pm CET<br>
                Saturday: 10am to 2pm CET<br>
                Sunday: 10am to 2pm CET<br>
            </v-col>
        </v-row>
    </v-footer>
</template>
<script>
export default {
    
}
</script>